"use strict";
/**
 * @module TopicNotifications
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var CommandService = require("./../client/command-service");
var registration_1 = require("./../control/registration");
var Services = require("./../services/topic-notifications-services");
var logger = require("./../util/logger");
var topic_notifications_1 = require("../../features/topic-notifications");
var log = logger.create('Session.Notifications');
/**
 * Implementation of the {@link TopicNotifications} feature
 */
var TopicNotificationsImpl = /** @class */ (function () {
    /**
     * Create a new TopicNotificationsImpl instance
     *
     * @param internal  the internal session
     */
    function TopicNotificationsImpl(internal) {
        /**
         * Exporting the {@link Session.notifications.TopicNotificationType}
         */
        this.TopicNotificationType = topic_notifications_1.TopicNotificationType;
        this.internal = internal;
        var serviceLocator = internal.getServiceLocator();
        this.conversationSet = internal.getConversationSet();
        this.TOPIC_NOTIFICATION_SELECTION = serviceLocator.obtain(Services.TOPIC_NOTIFICATION_SELECTION);
        this.TOPIC_NOTIFICATION_DESELECTION = serviceLocator.obtain(Services.TOPIC_NOTIFICATION_DESELECTION);
        this.TOPIC_NOTIFICATION_DEREGISTRATION = serviceLocator.obtain(Services.TOPIC_NOTIFICATION_DEREGISTRATION);
        var serviceRegistry = internal.getServiceRegistry();
        var eventService = CommandService.create(function (internalSession, request, callback) {
            callback.respond();
            internalSession.getConversationSet().respond(request.cid, request);
        });
        serviceRegistry.add(Services.TOPIC_NOTIFICATION_EVENTS, eventService);
        serviceRegistry.add(Services.TOPIC_DESCENDANT_EVENTS, eventService);
    }
    /**
     * @inheritdoc
     */
    TopicNotificationsImpl.prototype.addListener = function (listener) {
        var _this = this;
        var parseSelector = this.internal.getContext().parseSelector;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var adapter, conversationId;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!listener) {
                            reject(new Error('Topic Notification Listener is null or undefined'));
                            return [2 /*return*/];
                        }
                        if (!this.internal.checkConnected(reject)) return [3 /*break*/, 2];
                        log.debug('Adding Topic Notification Listener');
                        adapter = {
                            active: function (close, cid) {
                                log.debug('Topic Notification Listener active');
                                var topicNotificationRegistration = {
                                    select: function (topicSelector) {
                                        var args = [];
                                        for (var _i = 1; _i < arguments.length; _i++) {
                                            args[_i - 1] = arguments[_i];
                                        }
                                        return new Promise(function (selectResolve, selectReject) {
                                            if (!topicSelector) {
                                                selectReject(new Error('No topic selector provided'));
                                                return;
                                            }
                                            try {
                                                var selector = (args.length > 0)
                                                    ? parseSelector([topicSelector].concat(args))
                                                    : parseSelector(topicSelector);
                                                _this.TOPIC_NOTIFICATION_SELECTION.send({ cid: cid, selector: selector }, function (err) {
                                                    if (err) {
                                                        _this.conversationSet.discard(cid, err);
                                                        selectReject(err);
                                                    }
                                                    else {
                                                        selectResolve();
                                                    }
                                                });
                                            }
                                            catch (err) {
                                                selectReject(err);
                                            }
                                        });
                                    },
                                    deselect: function (topicSelector) {
                                        var args = [];
                                        for (var _i = 1; _i < arguments.length; _i++) {
                                            args[_i - 1] = arguments[_i];
                                        }
                                        return new Promise(function (deselectResolve, deselectReject) {
                                            if (!topicSelector) {
                                                deselectReject(new Error('No topic selector provided'));
                                                return;
                                            }
                                            try {
                                                var selector = (args.length > 0)
                                                    ? parseSelector([topicSelector].concat(args))
                                                    : parseSelector(topicSelector);
                                                _this.TOPIC_NOTIFICATION_DESELECTION.send({ cid: cid, selector: selector }, function (err) {
                                                    if (err) {
                                                        _this.conversationSet.discard(cid, err);
                                                        deselectReject(err);
                                                    }
                                                    else {
                                                        deselectResolve();
                                                    }
                                                });
                                            }
                                            catch (err) {
                                                deselectReject(err);
                                            }
                                        });
                                    },
                                    close: function () {
                                        _this.TOPIC_NOTIFICATION_DEREGISTRATION.send({ cid: cid }, function (err, response) {
                                            if (err) {
                                                _this.conversationSet.discard(cid, err);
                                                log.debug('Error with topic notification deregistration: ', err);
                                            }
                                            else {
                                                listener.onClose();
                                                _this.conversationSet.respondIfPresent(cid, response);
                                            }
                                        });
                                    }
                                };
                                resolve(topicNotificationRegistration);
                            },
                            respond: function (message) {
                                if (message.isDescendantEvent) {
                                    listener.onDescendantNotification(message.path, message.type);
                                }
                                else {
                                    listener.onTopicNotification(message.path, message.specification, message.type);
                                }
                                return false;
                            },
                            close: function (err) {
                                log.debug('Topic Notification Listener closed');
                                if (err) {
                                    listener.onError(err);
                                }
                                else {
                                    listener.onClose();
                                }
                            }
                        };
                        return [4 /*yield*/, this.conversationSet.newConversation(registration_1.responseHandler(this.internal, adapter, function (cid, callback) {
                                _this.TOPIC_NOTIFICATION_DEREGISTRATION.send({ cid: cid }, callback);
                            }))];
                    case 1:
                        conversationId = _a.sent();
                        registration_1.registrationCallback(this.conversationSet, conversationId, function () { }, function () { })(undefined);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    return TopicNotificationsImpl;
}());
exports.TopicNotificationsImpl = TopicNotificationsImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/features/topic-notifications.js
// module id = 1472
// module chunks = 1